const isTest = process.env.REACT_APP_ENV === 'development';
module.exports.PricingIndiaUrls = {
    "starter-monthly": isTest ? "https://buy.stripe.com/test_cN2eVHePVb0O1hK7su": "https://buy.stripe.com/00g6qX5HZgB08gMeUU",
    "starter-annual": isTest ? "https://buy.stripe.com/test_00g00N6jpfh40dGcMP" : "https://buy.stripe.com/eVa16Deev0C2gNi005",
  
    "growth-monthly": isTest ? "https://buy.stripe.com/test_aEU4h38rx0mae4wcMQ" : "https://buy.stripe.com/fZeg1xb2j70q0Ok146",
    "growth-annual": isTest ? "https://buy.stripe.com/test_7sIbJv9vB0ma5y04gn" : "https://buy.stripe.com/fZeaHdfiz4SidB6aEK",
  
    "pro-monthly": isTest ? "https://buy.stripe.com/test_28ofZL5fled0bWo8wG" : "https://buy.stripe.com/4gw6qX7Q7fwWfJe7sB",
    "pro-annual": isTest ? "https://buy.stripe.com/test_3cs4h37nted00dGbIQ" : "https://buy.stripe.com/eVag1x4DVacCaoU14e",
  
    "business-monthly": isTest ? "https://buy.stripe.com/test_eVa6pbdLR4Cq3pS14a" : "https://buy.stripe.com/5kA6qX3zR70qcx27sA",
    "business-annual": isTest ? "https://buy.stripe.com/test_3csaFr8rx9WK7G8fZ7" : "https://buy.stripe.com/8wM3eL6M3acC7cI3cn",
  };